interface ParamsType {
  _id: string;
  sender_id: string;
  sender_id_type: 'system' | string;
  recipient_id: string;
  recipient_id_type?: string;
  job_id?: string | { _id?: string; id?: string } | null;
  message: string;
  type: 'notification' | string;
  readed: boolean;
  status: 'pending' | 'read' | 'archived' | string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  metaData:{
    type:string,
    related:string,
    id:string
  }
   
}

export const NotificationLink = (params:ParamsType) => {
  const jobId =
    typeof params?.job_id === 'string'
      ? params?.job_id
      : params?.job_id?._id || params?.metaData?.id;

  const isFromCompany = params?.sender_id_type === 'company' || params?.recipient_id_type === 'cleaner';
  const isFromCleanerToCompany = (params?.sender_id_type === 'cleaner' || params?.recipient_id_type === 'company') && params?.recipient_id_type !== 'individual';
  const isFromCleanerToIndividual = params?.sender_id_type === 'cleaner' && params?.recipient_id_type === 'individual';
  const isFromIndividualToCleaner = params?.sender_id_type === 'individual' || params?.recipient_id_type === 'cleaner';

  const cleanerId = typeof params?.sender_id === 'string' ? params?.sender_id : ((params?.sender_id as any)?._id || (params?.sender_id as any)?.id);

  if (params?.type === 'chat' && jobId) {
    if (isFromCompany || (params?.sender_id_type === 'system' && params?.metaData?.related === 'cleaner')) {
      return `/cleaner/message?jobId=${jobId}`
    }
    if (isFromCleanerToIndividual) {
      return `/individual/confirm-and-chat/${jobId}`
    }
    if (isFromCleanerToCompany) {
      return `/messages?jobId=${jobId}${cleanerId ? `&cleanerId=${cleanerId}` : ''}`
    }
    return `/messages?jobId=${jobId}`
  }

  if((!params?.metaData?.id) || (!params?.metaData?.type) || (!params?.metaData?.related)){
    return ''
  }
  
  if(params?.metaData?.related === 'cleaner' && params?.metaData?.type==='new_job_post'){
    return `/job-detail/${params?.metaData?.id}`
  }
  if(params?.metaData?.related === 'cleaner' && params?.metaData?.type==='new_work_order_posted'){
    return `/cleaner/work-order-details/${params?.metaData?.id}`
  }
  if (
    params?.metaData?.related === 'cleaner' &&
    [
      'workorder_approved',
      'workorder_schedule_changed',
      'reminder_wo_scheduled_to_start_soon',
      'Reminder: Work Order is scheduled to start soon',
      'workorder_acceptance_reminder',
    ].includes(params?.metaData?.type)
  ) {
    return `/my-job-details/${params?.metaData?.id}`
  }
  if (
    params?.metaData?.related === 'cleaner_workorder_payment_sent' &&
    params?.metaData?.type === 'workorder_updated'
  ) {
    return `/my-job-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='workorder_assigned'){
    return `/my-job-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='individual_workorder_assigned'){
    return `/my-job-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='stripe_account_reminder'){
    return '/cleaner-profile-page?tab=payment-settings'
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='workorder_applied'){
        return `/work-order-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='job_applied'){
    return `/postedjob-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='supervisor_register'){
    return `/supervisor-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='supervisor_rejected_workorder'){
        return `/work-order-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='company_paid_amount'){
    return  `/work-order-details/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='work_order_completed'){
    return `/work-order-progress/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='company' && params?.metaData?.type==='workorder_approved'){
        return `/work-order-progress/${params?.metaData?.id}`     
  }
  if(params?.metaData?.related==='company' && (params?.metaData?.type==='individual_workorder_accepted' || params?.metaData?.type==='individual_workorder_rejected')){
    return `/work-order-progress/${params?.metaData?.id}`
  }
   if(params?.metaData?.related === 'cleaner' && params?.metaData?.type==='workorder_rejection'){
    return `/cleaner/applied-work-order`
  }
  if(params?.metaData?.related==='supervisor' && params?.metaData?.type==='work_order_available_for_review'){
return `/supervisor/manage-work-order/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='IndividualJob_Deadline'){
    return `/cleaner/individual/chat/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='individualjob_noshow'){
  
    
    return `/cleaner/individual/chat/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='individual' && params?.metaData?.type==='individualjob_noshow'){

    
    return `/individual/confirm-and-chat/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='cleaner' && params?.metaData?.type==='individualjob_cancel'){
 
    
    return `/cleaner/individual/chat/${params?.metaData?.id}`
  }
  if(params?.metaData?.related==='individual' && params?.metaData?.type==='individualjob_cancel'){
  
    
    return `/individual/confirm-and-chat/${params?.metaData?.id}`
  }
  if(params?.metaData?.related === 'cleaner' && params?.metaData?.type==='checkr_validation'){
    return `/cleaner-profile-page?tab=checkr-content`
  }
  if(params?.metaData?.related === 'cleaner' && params?.metaData?.type==='cleaner_profile_completion'){
    return `/cleaner-profile-page`
  }
};
